export const SET_LOGGEDIN = 'SET_LOGGEDIN'
export const SET_LOGIN_DETAILS = 'SET_LOGIN_DETAILS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const SET_LOGIN_MESSAGE = 'SET_LOGIN_MESSAGE'
export const CLEAR_USER_DATA = 'CLEAR_USER_DATA'
export const SET_USER_DETAILS = 'SET_USER_DETAILS'